// native-http.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { CapacitorHttp } from '@capacitor/core';

@Injectable()
export class NativeHttpInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Run native http only on iOS
        // Intercept to tmv
        const isTmv = req.url.startsWith('https://topomapviewer.ngi.be') && !req.url.includes('forwardproxy');

        //android requests will be made with referer https://localhost/* , not ok for e.g. csrf token request
        //so update referer & origin if necessary
        let updatedReq = req;
        if(Capacitor.isNativePlatform() && (!req.headers.get('Referer') || req.headers.get('Referer').indexOf('//localhost') > -1)){
             updatedReq = req.clone({
              headers: req.headers
                .set('Referer', 'https://topomapviewer.ngi.be').set('Origin', 'https://topomapviewer.ngi.be')
            });
        }

        //Interceptors only see requests made with Angular HttpClient
        // dont touch this request - web
        if (req.url.includes('/tmv-services/security/csrf')) {
            return next.handle(updatedReq);
        }
        if (req.url.includes('routes/save')) {
            // console.log('routes/save via web request', req)
            return next.handle(updatedReq);
        }
        //if (req.url.includes('sendCartowebRemark')) {
            // console.log('send sendCartowebRemark via web request', req)
            //return next.handle(updatedReq);
        //}

        //Native http req
        if (Capacitor.isNativePlatform() && isTmv) {
            return from(this.handleNativeHttp(updatedReq));
        }
        // console.log('web request ', req);
        return next.handle(updatedReq);
    }
    // !!! data can only be a string or a JSON. FormData, Blob, ArrayBuffer, and other complex types are only directly supported on web
    private async handleNativeHttp(req: HttpRequest<any>): Promise<HttpResponse<any>> {
        //console.log("caphttp")
        // headers
        console.dir(req)
        const headers: Record<string, string> = {};
        req.headers.keys().forEach(key => {
            headers[key] = req.headers.get(key) || '';
        });
        /*
        already set in intercept method
        headers['Referer'] = 'https://topomapviewer.ngi.be';
        headers['Origin'] = 'https://topomapviewer.ngi.be';
        */
        // Normalize body
        let body: any = req.body;
        if (body instanceof FormData) {
            // Convert FormData → plain object
            body = Object.fromEntries(body as any);
        } else if (body && typeof body !== 'string') {
            try {
                body = JSON.parse(JSON.stringify(body)); // force serializable
            } catch {
                body = {}; // fallback
            }
        }
        const response = await CapacitorHttp.request({
            method: req.method,
            url: req.url,
            headers,
            data: body,
        });
        return new HttpResponse({
            body: response.data,
            status: response.status,
            url: req.url,
        });
    }
}